import { createReducer, on, createFeature } from '@ngrx/store'
import { ExperienceState } from './experience.state'
import {
  createExperience,
  createExperienceFailure,
  createExperienceSuccess,
  deleteExperience,
  deleteExperienceFailure,
  deleteExperienceSuccess,
  loadExperiences,
  loadExperiencesFailure,
  loadExperiencesSuccess,
  updateExperience,
  updateExperienceFailure,
  updateExperienceSuccess
} from './experience.actions'

export const initialState: ExperienceState = {
  experiences: [],
  loading: false,
  error: null,
  totalExperienceYears: 0
}

export const experienceReducer = createReducer(
  initialState,
  on(loadExperiences, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(loadExperiencesSuccess, (state, { experiences, totalExperienceYears }) => ({
    ...state,
    experiences: experiences,
    loading: false,
    error: null,
    totalExperienceYears
  })),
  on(loadExperiencesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(createExperience, state => ({ ...state, loading: true })),
  on(createExperienceSuccess, (state, { experience }) => ({
    ...state,
    experiences: [...state.experiences, experience],
    loading: false
  })),
  on(createExperienceFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(updateExperience, state => ({ ...state, loading: true })),
  on(updateExperienceSuccess, (state, { experience }) => ({
    ...state,
    experience,
    loading: false
  })),
  on(updateExperienceFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(deleteExperience, (state, { id }) => ({
    ...state,
    Experiences: state.experiences.map(experience =>
      String(experience.id) === id ? { ...experience, disabled: true } : experience
    )
  })),
  on(deleteExperienceSuccess, (state, { id }) => {
    // Update the business state to reflect that it is successfully deleted
    const updatedState = {
      ...state,
      Experiences: state.experiences.filter(b => b.id !== id), // Remove the business from the list
      error: null
    }
    return updatedState
  }),
  on(deleteExperienceFailure, (state, { error }) => ({
    ...state,
    error
  }))
)

// Create the feature for the business state
export const experienceFeature = createFeature({
  name: 'Experience', // Feature name
  reducer: experienceReducer
})
export type { ExperienceState }
// Export the feature's selectors
export const {
  name,
  reducer,
  selectExperiences,
  selectLoading,
  selectError,
  selectTotalExperienceYears
} = experienceFeature
